import { on } from "delegated-events";
import scrollTo from '../common/scrollTo'

const dropdown = document.querySelector(".dropdown");
const tpOne = document.querySelector(".TP584");
const tpTwo = document.querySelector(".TP584-2");
const rpAG = document.querySelector(".RP5217AG");
const rpState = document.querySelector(".RP5217State");
const numberofPages = document.querySelector(".numberofpages");
const numberofNotations = document.querySelector(".numberofnotations");
const totalnumofpages = document.querySelector(".totalpages");
const endvalues = document.querySelectorAll(".cover");
const numofpgvalue = document.querySelector(".numofpgvalue");
const tpOnedisplay = document.querySelector(".tponevalue");
const tpTwodisplay = document.querySelector(".tptwovalue");
const agValue = document.querySelector(".agvalue");
const stateValue = document.querySelector(".statevalue");
const consideration = document.querySelector(".considerationamount");
const propertyclass = document.querySelector(".propertyclass");
const result = document.querySelector(".calcOut");

let total = 0;
let totalcost = 0;

const fn = {
    init: () => {
        document.querySelector(".RP5217State").setAttribute("disabled", "");
        document.querySelector(".RP5217AG").value = 1;
        document.querySelector(".RP5217State").value = "";
        document.querySelector(".RP5217AG").setAttribute("disabled", "");
        document.querySelector(".tta").setAttribute("disabled", "");
        document.querySelector(".NOTOS").setAttribute("disabled", "");
        document.querySelector(".tta").value = "$ 0.00";
        document.querySelector(".coverpgin").value = 1;
        document.querySelector(".considerationamount").setAttribute("disabled", "");
        document.querySelector(".TP584").setAttribute("disabled", "");
        document.querySelector(".TP584").value = 1;

        let selectedValue = dropdown.value;

        tpOne.addEventListener("input", function () {
            document.querySelector(".TP584-2").setAttribute("disabled", "");
        });
        tpTwo.addEventListener("input", function () {
            if ((document.querySelector(".TP584-2").value = 1)) {
                document.querySelector(".TP584").setAttribute("disabled", "");
                document.querySelector(".TP584").value = "";
            }
        });
        propertyclass.addEventListener("input", fn.debounce(fn.propertyclasscalc, 300));

        on('click', '.clear', fn.clear);
        on('click', '.calculate', fn.calculate);
        on('click', '.print', fn.handlePrint);

        on('change', '.dropdown', function () {
            selectedValue = dropdown.value;
            if (selectedValue === "commercial") {
                /* document.querySelector(".RP5217State").setAttribute("disabled", "");
                document.querySelector(".RP5217State").value = 1;
                document.querySelector(".RP5217AG").value = "";
                document.querySelector(".RP5217AG").setAttribute("disabled", ""); */
                document.querySelector(".considerationamount").disabled = false;
            } else if (selectedValue === "exempt") {
                /*   document.querySelector(".RP5217State").setAttribute("disabled", "");
                document.querySelector(".RP5217AG").value = 1;
                document.querySelector(".RP5217State").value = "";
                document.querySelector(".RP5217AG").setAttribute("disabled", ""); */
                document
                    .querySelector(".considerationamount")
                    .setAttribute("disabled", "");
            } else {
                /* document.querySelector(".RP5217State").setAttribute("disabled", "");
                document.querySelector(".RP5217AG").value = 1;
                document.querySelector(".RP5217State").value = "";
                document.querySelector(".RP5217AG").setAttribute("disabled", ""); */
                document.querySelector(".considerationamount").disabled = false;
            }
        });
    },

    clear: () => {
        total = 0;
        numberofPages.value = "";
        totalnumofpages.value = "";
        numberofNotations.value = "";
        consideration.value = "";

        document.querySelector(".TP584").disabled = false;
        document.querySelector(".TP584-2").disabled = false;
        document.querySelector(".TP584").value = "";
        document.querySelector(".TP584-2").value = "";
        document.querySelector(".tta").value = "$ 0.00";
        document.querySelector(".RP5217State").setAttribute("disabled", "");
        document.querySelector(".RP5217AG").value = 1;
        document.querySelector(".RP5217State").value = "";
        document.querySelector(".RP5217AG").setAttribute("disabled", "");
        document.querySelector(".tta").setAttribute("disabled", "");
        document.querySelector(".NOTOS").setAttribute("disabled", "");
        document.querySelector(".TP584").setAttribute("disabled", "");
        document.querySelector(".TP584").value = 1;
        document.querySelector(".propertyclass").value = "";

        endvalues.forEach(function (element) {
            element.classList.add("cover");
            element.classList.remove("showup");
        });
    },

    propertyclasscalc: () => {
        const propertyclassnum = Number(parseInt(propertyclass.value));
        if (propertyclassnum === 411) {
            document.querySelector(".RP5217State").setAttribute("disabled", "");
            document.querySelector(".RP5217AG").value = 1;
            document.querySelector(".RP5217State").value = "";
            document.querySelector(".RP5217AG").setAttribute("disabled", "");
        } else if (propertyclassnum < 300) {
            document.querySelector(".RP5217State").setAttribute("disabled", "");
            document.querySelector(".RP5217AG").value = 1;
            document.querySelector(".RP5217State").value = "";
            document.querySelector(".RP5217AG").setAttribute("disabled", "");
        } else {
            document.querySelector(".RP5217State").setAttribute("disabled", "");
            document.querySelector(".RP5217State").value = 1;
            document.querySelector(".RP5217AG").value = "";
            document.querySelector(".RP5217AG").setAttribute("disabled", "");
        }
    },

    taxcalc: (considerationvalue, total, totalcost) => {
        if (considerationvalue <= 500 || consideration.value === "") {
            totalcost = 0;
        } else {
            const divider = considerationvalue / 500;
            const multnum = Math.ceil(divider);
            totalcost = multnum * 2;
            total += totalcost;
        }
        return totalcost;
    },

    checknumpages: (variable, total) => {
        if (variable === 1) {
            const price = 10;
            numofpgvalue.textContent = `${price.toFixed(2)}`;
            return 10;
        } else if (variable === 0 || variable === "") {
            variable = 0;
            numofpgvalue.textContent = `${variable.toFixed(2)}`;
            return 0;
        } else {
            let pagesvalue = 10 + (variable - 1) * 5;
            numofpgvalue.textContent = `${pagesvalue.toFixed(2)}`;
            return pagesvalue;
        }
    },

    calculate: () => {
        let totalpages = 0;
        let total = 0;
        let totalcost = 0;
        let ttacost = 0;
        const considerationvalue = Number(consideration.value);
        ttacost = fn.taxcalc(considerationvalue, total, totalcost);
        let numpages = Number(numberofPages.value);
        totalpages = numpages + 1;
        totalnumofpages.value = totalpages;
        // notationdisplay.textContent = (Number(numberofNotations.value) * 0.5).toFixed(
        //     2
        // );
        if (tpOne.value === "") {
            const tptwonumber = Number(tpTwo.value) * 1;
            tpOnedisplay.textContent = "0.00";
            tpTwodisplay.textContent = `${tptwonumber.toFixed(2)}`;
            total += tptwonumber;
        } else if (tpTwo.value === "") {
            const tponenumber = Number(tpOne.value) * 5;
            tpTwodisplay.textContent = "0.00";
            tpOnedisplay.textContent = `${tponenumber.toFixed(2)}`;
            total += tponenumber;
        }
        if (rpAG.value === "") {
            const rpAGnumber = 241;
            agValue.textContent = "0.00";
            stateValue.textContent = `${rpAGnumber.toFixed(2)}`;
            total += rpAGnumber;
        } else if (rpState.value === "") {
            const rpStatenumber = 116;
            stateValue.textContent = "0.00";
            agValue.textContent = `${rpStatenumber.toFixed(2)}`;
            total += rpStatenumber;
        }

        document.querySelector(".tta").value = `$ ${ttacost.toFixed(2)}`;

        total += 14.25 + 1.0 + 4.75 + 9 + 20;

        total += Number(numberofNotations.value) * 0.5;

        total += fn.checknumpages(numpages, total);

        total += ttacost;

        document.querySelector(".totalcost").textContent = `${total.toFixed(2)}`;

        const initialButtonsContainer = document.querySelector(".initial-buttons");

        if (!initialButtonsContainer.classList.contains("hidden")) {
            initialButtonsContainer.classList.add("hidden");
        }

        // result.classList.remove("hidden");
        result.classList.add("shown");
        scrollTo(result);
    },

    handlePrint: () => {
        const results = document.querySelector("#calculator-results").innerHTML;

        const printContent = `
        <html>
            <head>
                <title>Calculator Results</title>
                <link rel="preload" href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap" as="style">
                <style>
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                    }
                    body {
                        font-family: 'Lato', sans-serif; /* Apply Lato font */
                    }
                    hr {
                        margin-top: 1.5rem;
                        margin-bottom: 1.5rem;
                        opacity: 0.2;
                        max-width: 90%;
                    }
                    h3 {
                        text-align: center;
                        font-size: 1.875rem;
                        font-weight: 400;
                    }
                    p {
                        margin: 0;
                    }
                    ul {
                        list-style-type: none;
                    }
                    li {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 15px;
                        padding-block: 2px;

                        p {
                            text-align: right;
                            font-size: 16px;
                            font-weight: 300;
                        }

                        span:not(.total-amount) {
                            font-size: 20px;
                            font-weight: 400;
                        }
                    }
                    .calculator-results {
                        padding: 20px;
                        max-width: 34rem;
                        margin: auto;
                        border-radius: 8px;
                        background-color: #213bc0;
                        color: #fff;
                    }
                    li.total-row {
                        align-items: center;

                        p {
                            font-weight: 600;
                        }
                    }
                    span.total-amount {
                        font-size: 30px;
                    }
                </style>
            </head>
            <body>
                <div class="calculator-results">
                    ${results}
                </div>
            </body>
        </html>
        `;

        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.open();
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
    },

    debounce: (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        }
    }
}

export default {
    can: () => document.querySelector('.deed-calculator-element'),
    run: fn.init,
}
